import * as React from 'react';
import ImageOverlay from '../ImageOverlay';
import { ImageObject } from '../../utils/types';
import { ImageWrapper, Container, AllImagesWrapper, Header } from './Elements';
import NoDataHandler from '../NoDataHandler';
import Box from '../primitives/Box';

type Props = {
  heading?: string;
  buttonText?: string;
  loading?: boolean;
  onButtonPress?: () => void;
  onClickRemove: (d?: string | number | null) => void;
  data?: ImageObject[] | null;
  onOrderPress?: () => void;
};

const Gallery: React.FC<Props> = ({
  data,
  heading,
  loading,
  onButtonPress,
  buttonText,
  onClickRemove,
  onOrderPress,
}) => {
  function renderImages(images: ImageObject[]) {
    return images.map((image: ImageObject, index: number) => {
      return (
        <ImageWrapper key={index}>
          <Container src={image && image.scaled} />
          <ImageOverlay
            loading={loading}
            onClick={() => onClickRemove(image.id ? image.id : image.original)}
            top={true}
            remove={true}
            noText={true}
          />
        </ImageWrapper>
      );
    });
  }

  return (
    <React.Fragment>
      <Header
        loading={loading}
        heading={heading}
        buttonText={buttonText}
        onClickRemove={onClickRemove}
        onButtonPress={onButtonPress}
        onOrderPress={onOrderPress}
        images={data && data.length > 0}
      />
      <AllImagesWrapper>
        {data && renderImages(data)}
        {!loading && data && data.length === 0 && (
          <Box width="100%" flex={1}>
            <NoDataHandler />
          </Box>
        )}
      </AllImagesWrapper>
    </React.Fragment>
  );
};

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/gallery/Gallery.tsx